import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

interface Founder {
  userId: number;
  nickname: string;
  percentage?: number;
  icon?: string;
  nft?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  userIndexDetails?: {
    userIndex: number;
    userIndexDiff: number;
    userIndexAmbassador: number;
    userIndexCreator: number;
    userIndexHelper: number;
  };
  status?: string;
}

@Component({
  selector: 'ark-lib-founders-block',
  templateUrl: './founders-block.component.html',
  styleUrls: ['./founders-block.component.css'],
})
export class FoundersBlockComponent implements OnChanges {
  @Input() founderData!: Founder;
  @Input() allFounders: Founder[] = [];
  @Input() isMine: boolean = false;
  @Input() displayFounderBox: boolean = true;

  founderPercentage: number = 100;

  ngOnChanges(changes: SimpleChanges) {
    // Convert all founder percentages from decimal to percent for display
    if (changes['allFounders'] && this.allFounders) {
      const creatorUserId = this.founderData?.userId;
      if (creatorUserId !== undefined && creatorUserId !== null) {
        this.allFounders = this.allFounders.filter(
          (f) => f.userId !== creatorUserId,
        );
      }

      this.allFounders.forEach(f => {
        if (f.percentage !== undefined && f.percentage <= 1) {
          f.percentage = +(f.percentage * 100).toFixed(2);
        }
        if (!f.status) {
          f.status = 'invited';
        }
      });
      this.allFounders = this.allFounders.filter(
        (f) => f.percentage === undefined || f.percentage > 0,
      );
      // Calculate creator percentage as remainder
      const sumOfFounders = this.allFounders.reduce(
        (sum, f) => sum + (f.percentage || 0),
        0,
      );
      this.founderPercentage = Math.max(1, +(100 - sumOfFounders).toFixed(2));
    }
  }
}
